@if (!isNetvote()) {
    <button class="menu-toggle" mat-icon-button (click)="toggleSidebar()">
        <mat-icon matListIcon>{{ isSidebarOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
}
<mat-sidenav-container class="sidenav-container" [hasBackdrop]="false">
    @if (!isNetvote()) {
        <mat-sidenav class="sidenav" mode="side" disableClose opened="true" fixedInViewport="true">
            <mat-toolbar class="sidebar-toolbar">
                <img src="{{ currentLogo }}" class="logo" />
            </mat-toolbar>
            <mat-nav-list class="navigation-list">
                @for (menuItem of menuItems; track menuItem) {
                    @if (!menuItem.isParentForSubMenu) {
                        <a
                            mat-list-item
                            matTooltip="{{ 'MenuItem.' + menuItem.title | translate }}"
                            [matTooltipDisabled]="!isSidebarNarrow"
                            [matTooltipPosition]="'right'"
                            class="navigation-item"
                            [routerLink]="menuItem.getFullPath()"
                            routerLinkActive="list-item-active">
                            <mat-icon matListItemIcon>{{ menuItem.icon }}</mat-icon>
                            <span class="navigation-item-label">{{ 'MenuItem.' + menuItem.title | translate }}</span>
                        </a>
                    } @else {
                        <mat-accordion>
                            <mat-expansion-panel (opened)="openSidebar()" hideToggle>
                                <mat-expansion-panel-header class="sidenav-toggle-menu-header">
                                    <mat-panel-title>
                                        <mat-icon matListItemIcon>{{ menuItem.icon }}</mat-icon>
                                        <span
                                            matTooltip="{{ 'MenuItem.' + menuItem.title | translate }}"
                                            class="navigation-item-label"
                                            [matTooltipDisabled]="!isSidebarNarrow"
                                            [matTooltipPosition]="'right'">
                                            {{ 'MenuItem.' + menuItem.title | translate }}
                                        </span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                @for (menuSubItem of menuItem.children; track menuSubItem) {
                                    <a
                                        mat-list-item
                                        matTooltip="{{ 'MenuItem.' + menuSubItem.title | translate }}"
                                        [matTooltipDisabled]="!isSidebarNarrow"
                                        [matTooltipPosition]="'right'"
                                        class="navigation-item"
                                        [routerLink]="menuSubItem.getFullPath()"
                                        routerLinkActive="list-item-active">
                                        <span class="navigation-sub-item-label">
                                            {{ 'MenuItem.' + menuSubItem.title | translate }}
                                        </span>
                                    </a>
                                }
                            </mat-expansion-panel>
                        </mat-accordion>
                    }
                }
            </mat-nav-list>
            <button
                class="menu-resize"
                mat-icon-button
                (click)="resizeSidebar()"
                matTooltip="{{ (isSidebarNarrow ? 'General.Expand' : 'General.Collapse') | translate }}"
                [matTooltipPosition]="'right'">
                <mat-icon matListIcon>{{ isSidebarNarrow ? 'menu' : 'menu_open' }}</mat-icon>
            </button>
        </mat-sidenav>
    }
    <mat-sidenav-content #content class="sidenav-content">
        <sl-topbar [isNetvote]="isNetvote()" />
        <router-outlet />
    </mat-sidenav-content>
</mat-sidenav-container>
